import { useState, useEffect } from 'react';
import storage from '@xto10x/storage/lib';
import { StorageKey } from 'utils/constants';
import isAuthenticated from '@xto10x/oauth2/lib/isAuthenticated';
import {
  isSignedInWithGoogle,
  isSignedInWithMicrosoft,
  isSignedInWithCognito
} from '@xto10x/oauth2/lib/getSignedInWith';
import {
  googleSignInRequestAction,
  emailSignInRequestAction
} from 'containers/Authentication/store/actions';
import Auth from '@xto10x/core/lib/cognito.auth';
import { validateAppVersion } from '../HelperFunctions/AppVersionValidator';
import { fetchAppData } from '../store/actions';
import {
  redirectIfOnBoardedToPeopleCues,
  redirectIfOrgSubDomainNeedsChange
} from '../../../utils/app.utils';

export default props => {
  const [isInitialized, setIsInitialized] = useState(false);

  const hasCookieAndStorageAccess =
    storage.hasCookieAccess() && storage.hasLocalStorageAccess();

  // Removed onFocus and onBLur functionality as we are using broadcast channel
  useEffect(() => {
    if (!props.setIsSignedIn) return;
    isAuthenticated()
      .then(() => props.setIsSignedIn(true))
      .catch(() => props.setIsSignedIn(false));
  }, [props.setIsSignedIn]);

  useEffect(() => {
    if (props.isNewAppVersionAvailable)
      validateAppVersion(props.isNewAppVersionAvailable, props.dispatch);
  }, [props.isNewAppVersionAvailable]);

  const initializeApp = async () => {
    if (!props.isSignedIn) {
      await Auth.signOut().catch(() => null);
      storage.clearAllStorage(
        false,
        StorageKey.REVIEW_DRAFT_DATA,
        StorageKey.REVIEW_LAST_PAGE
      );
      setIsInitialized(true);
      return;
    }
    setIsInitialized(false);
    const localOrgData = storage.getDataFromLocal(StorageKey.ORG_INFO);
    const isOrgSyncNeeded = storage.getDataFromLocal(
      StorageKey.IS_ORG_SYNC_NEEDED
    );
    const userInfo = storage.getDataFromLocal(StorageKey.USER_INFO);
    const user_reference_id = storage.getDataFromLocal(
      StorageKey.REQUESTER_USER_ID
    );
    const user_orgs = storage.getDataFromLocal(StorageKey.USER_ORGS);
    const isRedirectingToPeopleCuesInProcess = await redirectIfOnBoardedToPeopleCues(
      localOrgData
    );
    let isRedirectingToDifferentSubdomainInProcess = false;
    if (!isOrgSyncNeeded) {
      isRedirectingToDifferentSubdomainInProcess = await redirectIfOrgSubDomainNeedsChange(
        localOrgData
      );
    }
    if (
      !isRedirectingToPeopleCuesInProcess &&
      !isRedirectingToDifferentSubdomainInProcess
    ) {
      storage.removeDataFromLocal(StorageKey.IS_ORG_SYNC_NEEDED);
      if (localOrgData && userInfo && user_reference_id && user_orgs) {
        props.dispatch(fetchAppData());
        setIsInitialized(true);
        return;
      }
      if (isSignedInWithGoogle() || isSignedInWithMicrosoft()) {
        props.dispatch(googleSignInRequestAction());
        setIsInitialized(true);
        return;
      }
      if (isSignedInWithCognito()) {
        props.dispatch(emailSignInRequestAction());
        setIsInitialized(true);
      }
    }
  };

  useEffect(() => {
    if (props.isSignedIn !== null && hasCookieAndStorageAccess) initializeApp();
  }, [props.isSignedIn]);

  return { isInitialized, hasCookieAndStorageAccess };
};
